import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { AuthCallbackComponent } from './auth/auth-callback/auth-callback.component';
import { AuthGuard } from './auth/auth.guard';
import { AccessibilityComponent } from './shared/components/accessibility/accessibility.component';
import { SitemapComponent } from './shared/components/sitemap/sitemap.component';
import { UnauthorizedComponent } from './shared/components/unauthorized/unauthorized.component';
import { RoleGuard } from './auth/role.guard';

const routes: Routes = [

  // SIN GUARDS
  {
    path: 'auth-callback',
    component: AuthCallbackComponent
  },

  // ZONA PROTEGIDA
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'curriculum',
        loadChildren: () =>
          import('./feature-modules/curriculum/curriculum.module')
            .then(m => m.CurriculumModule),
        canLoad: [RoleGuard],
        canActivate: [RoleGuard],
        data: { roles: ['ASESOR_CV', 'ADMIN'] }
      },
      {
        path: 'jobseeker',
        loadChildren: () =>
          import('./feature-modules/jobseeker/jobseeker.module')
            .then(m => m.JobseekerModule),
        canLoad: [RoleGuard],
        canActivate: [RoleGuard],
        data: { roles: ['ASESOR_CV', 'ADMIN'] }
      },
      {
        path: 'job-offers',
        loadChildren: () =>
          import('./feature-modules/job-offers/job-offers.module')
            .then(m => m.JobOffersModule),
        canLoad: [RoleGuard],
        canActivate: [RoleGuard],
        data: { roles: ['GESTOR_OFERTAS', 'ADMIN'] }
      },
      {
        path: 'management',
        loadChildren: () =>
          import('./feature-modules/management/management.module')
            .then(m => m.ManagementModule),
        canLoad: [RoleGuard],
        canActivate: [RoleGuard],
        data: { roles: ['USER_ADMIN', 'ADMIN'] }
      },

      { path: '', redirectTo: 'curriculum', pathMatch: 'full' },
      { path: 'accesibilidad', component: AccessibilityComponent },
      { path: 'mapa-web', component: SitemapComponent },
      { path: 'unauthorized', component: UnauthorizedComponent }
    ]
  },

  { path: '**', redirectTo: '' }
];

const routerOptions: ExtraOptions = {
  useHash: false,
  anchorScrolling: 'enabled',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
